import { render, staticRenderFns } from "./staffSafetyDetail.vue?vue&type=template&id=e63392e8&scoped=true&"
import script from "./staffSafetyDetail.vue?vue&type=script&lang=js&"
export * from "./staffSafetyDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffSafetyDetail.vue?vue&type=style&index=0&id=e63392e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63392e8",
  null
  
)

export default component.exports